import { GetServerSidePropsContext } from "next";
import { en, es } from "@lang";
import { useEffect } from "react";
import Head from "next/head";
import { CircularProgress, Grid } from "@mui/material";
import React from "react";
import useDataLayerEvent from "custom-hooks/data-layer-event.hook";
export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

export default function Redirect(props: any) {
  const { event } = useDataLayerEvent();

  async function loadEvent() {
    const url = new URL(window.location.href.trim());
    const paramsObject = Object.fromEntries(url.searchParams.entries());
    const dataLayerEvent = paramsObject?.event_data_layer;

    await simulatorRequest({
      onEndSimulated: "resolve",
      onSuccessData: {},
    });

    if (dataLayerEvent) {
      event({
        event_name: dataLayerEvent,
        body: { ...paramsObject },
      });
    } else {
      console.log("no data layer event");
    }

    await simulatorRequest({
      onEndSimulated: "resolve",
      onSuccessData: {},
    });
    if (!paramsObject.redirect) {
      window.location.href = "/";
    } else {
      window.location.href = paramsObject.redirect;
    }
  }

  useEffect(() => {
    if (typeof window === "undefined") {
      console.log("window is undefined");
      return;
    }

    loadEvent();
  }, []);

  return (
    <>
      <Head>
        <title>Redirect</title>
      </Head>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ height: "90vh" }}
      >
        <CircularProgress
          sx={{
            width: "100px",
            height: "100px",
          }}
        />
      </Grid>
    </>
  );
}

interface SimulatorRequest {
  onEndSimulated: "resolve" | "reject";
  onErrorData?: any;
  onSuccessData?: any;
}
const simulatorRequest = async (arg: SimulatorRequest) => {
  return new Promise((resolve, reject) => {
    if (arg.onEndSimulated === "resolve") {
      setTimeout(() => {
        resolve(arg.onSuccessData || {});
      }, 500);
    } else {
      setTimeout(() => {
        reject(arg.onErrorData || {});
      }, 500);
    }
  });
};
